import { Box, Divider, Skeleton, Stack, useTheme } from "@mui/material";

const PrivilegesSkeleton = () => {
  const customTheme = useTheme();
  return (
    <>
      {[...Array(1)].map((_, index) => (
        <Box key={index} height={customTheme.dimensions.dimen245}>
          <Box
            display={customTheme.display.displayFlex}
            alignItems={customTheme.alignment.alignItems.center}
          >
            <Skeleton
              variant={customTheme.skeleton.variant.variantText}
              height={customTheme.dimensions.dimen28}
              width={customTheme.dimensions.dimen125}
            />
            <Divider
              sx={(theme) => ({
                flexGrow: 1,
                ml: theme.dimensions.dimen10,
                borderColor: theme.border.borderColour.borderE0E3E1,
              })}
            />
          </Box>

          {[...Array(4)].map((_, index) => (
            <Stack
              direction={customTheme.alignment.direction.row}
              spacing={customTheme.dimensions.dimen8}
              key={index}
              sx={(theme) => ({
                padding: `${theme.dimensions.dimen16} ${theme.dimensions.dimen0}`,
                alignItems: theme.alignment.alignItems.center,
                borderBottom: `1px solid ${theme.border.borderColour.borderE0E3E1}`,
              })}
            >
              <Skeleton
                variant={customTheme.skeleton.variant.variantText}
                height={customTheme.dimensions.dimen24}
                width={customTheme.dimensions.dimen200}
              />
              <Skeleton
                variant={customTheme.skeleton.variant.variantText}
                height={customTheme.dimensions.dimen24}
                width={customTheme.dimensions.dimen200}
              />
              <Skeleton
                variant={customTheme.skeleton.variant.variantText}
                height={customTheme.dimensions.dimen24}
                width={customTheme.dimensions.dimen200}
              />
              <Skeleton
                variant={customTheme.skeleton.variant.variantText}
                height={customTheme.dimensions.dimen24}
                width={customTheme.dimensions.dimen200}
              />
            </Stack>
          ))}
        </Box>
      ))}
    </>
  );
};
export default PrivilegesSkeleton;
